import { ROLE_OF_CENTER_LOADER, SET_ROLE_OF_CENTER_DATA } from "../actionTypes";

const initialState = {
  loader: false,
  pageData: {},
};

const roleOfCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ROLE_OF_CENTER_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_ROLE_OF_CENTER_DATA: {
      return {
        ...state,
        pageData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default roleOfCenterReducer;
